import { render, staticRenderFns } from "./PayAboutOrder.vue?vue&type=template&id=210eb86c&scoped=true&"
import script from "./PayAboutOrder.vue?vue&type=script&lang=js&"
export * from "./PayAboutOrder.vue?vue&type=script&lang=js&"
import style0 from "./PayAboutOrder.vue?vue&type=style&index=0&id=210eb86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210eb86c",
  null
  
)

export default component.exports